import Vue from 'vue';
import SingleSlider from '../Components/SingleSlider';

var v = new Vue({
    el: '#vaihtoauton-paastolaskuri',
    data: function () {
        return {
            km: [5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000],
            autonpaastot: (<any>window).autonpaastot,
            kilometrit: 5000,
        }
    },
    computed: {
         paastokg() {
            var paastokg = Math.round(this.autonpaastot * this.kilometrit ) / 1000;
            return new Intl.NumberFormat().format(paastokg);
        },
    },
    template: `<div>
                <div class="columns">
                   <div style="margin-right: 30px;">
                       <p class="margin__top-base">Tämän auton CO<sub>2</sub> päästöt: <strong>{{autonpaastot}} g/km </strong></p>
                   </div>
                   <div>
                        <p class="margin__top-base" style="min-width: 300px;">Vuotuinen ajomääräsi: <strong>{{Intl.NumberFormat().format(kilometrit)}} km</strong></p>
                        <section class="laskuri-section">      
                           <SingleSlider                       
                               :rangeValues="km" 
                               :tunniste="'kmslider'"
                               v-model="kilometrit"
                               style="width: 90%;"
                               class="rahoitusslider"
                           />
                       </section>
                   </div>
                </div>
                <div style="margin-top: 35px">
                   Autosi päästää yhteiseen ilmakehäämme <strong>{{paastokg}} kg</strong> hiilidioksidia vuodessa.
               </div>
           </div>`,

    components: {
        SingleSlider,
    }    
});
